<template>
  <div class="pgd-claim">
            <v-row class="claim-summary-row justify-center align-center">
              <v-col cols="12" class="claim-summary-column" md="6">
                <template>
                  <v-card
                    elevation="0"
                    class="cursor hover-pending claim-summary-card claim-summary-card--pegadaian"
                    @click="GetData('pendingpegadaian')"
                  >
                    <div class="claim-summary-content">
                      <div class="claim-summary-icon">
                        <v-icon>mdi-bank</v-icon>
                      </div>
                      <div class="claim-summary-copy">
                        <span>Pending Pegadaian</span>
                        <small>Menunggu kelengkapan dari Pegadaian</small>
                      </div>
                      <strong v-text="pending_pegadaian"></strong>
                      <v-icon class="claim-summary-arrow">mdi-arrow-right</v-icon>
                    </div>
                  </v-card>
                </template>
              </v-col>
              <v-col cols="12" class="claim-summary-column" md="6">
                <template>
                  <v-card
                    elevation="0"
                    class="cursor hover-pending claim-summary-card claim-summary-card--takaful"
                    @click="GetData('pendingtakaful')"
                  >
                    <div class="claim-summary-content">
                      <div class="claim-summary-icon">
                        <v-icon>mdi-shield-check</v-icon>
                      </div>
                      <div class="claim-summary-copy">
                        <span>Pending Takaful</span>
                        <small>Menunggu proses dari tim Takaful</small>
                      </div>
                      <strong v-text="pending_takaful"></strong>
                      <v-icon class="claim-summary-arrow">mdi-arrow-right</v-icon>
                    </div>
                  </v-card>
                </template>
              </v-col>
            </v-row>
            <v-tabs
              v-model="claimtab"
              class="claim-main-tabs"
              background-color="transparent"
              show-arrows
            >
              <v-tab href="#claimtab-1">
                <v-icon left>mdi-file-document-plus-outline</v-icon>
                Registrasi &amp; Dokumen
              </v-tab>
              <v-tab href="#claimtab-2">
                <v-icon left>mdi-file-search-outline</v-icon>
                Daftar Klaim
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="claimtab" class="claim-tab-content">
              <v-tab-item value="claimtab-1">
                <section v-if="!claim.claim_id" class="claim-empty-selection">
                  <div class="claim-empty-illustration">
                    <v-icon>mdi-file-search-outline</v-icon>
                  </div>
                  <h3>Belum ada klaim yang dipilih</h3>
                  <p>Pilih data klaim terlebih dahulu untuk melihat detail, progres, dan dokumennya.</p>
                  <v-btn depressed class="claim-open-list-btn" @click="claimtab = 'claimtab-2'">
                    <v-icon left>mdi-format-list-bulleted</v-icon>
                    Buka Daftar Klaim
                  </v-btn>
                </section>
                <template v-else>
                <section class="claim-progress-card claim-progress-card--inside" aria-label="Progres status klaim">
                  <div class="claim-progress-heading">
                    <div>
                      <span>Progres Klaim</span>
                      <small>Pantau tahapan penyelesaian klaim</small>
                    </div>
                    <v-chip class="claim-progress-status" small>
                      {{ claim.claim_status }}
                    </v-chip>
                  </div>
                  <div class="claim-progress-scroll">
                    <div class="claim-progress-track">
                      <template v-for="item in visibleClaimProgressSteps">
                        <div v-if="item.isEllipsis" :key="item.key" class="claim-progress-ellipsis" aria-label="Tahapan lainnya">
                          <span></span><span></span><span></span>
                        </div>
                        <div v-else :key="item.key" class="claim-progress-step" :class="{ 'is-complete': item.originalIndex < claimProgressIndex, 'is-active': item.originalIndex === claimProgressIndex, 'is-future': item.originalIndex > claimProgressIndex }">
                          <div class="claim-step-marker">
                            <v-icon v-if="item.originalIndex < claimProgressIndex" small>mdi-check</v-icon>
                            <span v-else>{{ item.originalIndex + 1 }}</span>
                          </div>
                          <div class="claim-step-label">{{ item.label }}</div>
                          <div class="claim-step-meta">
                            <template v-if="item.originalIndex === claimProgressIndex">Sedang diproses</template>
                            <template v-else-if="item.originalIndex < claimProgressIndex">Selesai</template>
                            <template v-else>Menunggu</template>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </section>
                <v-layout>
                  <v-row class="claim-detail-grid mx-2 my-5">
                    <v-col cols="12" md="6" class="claim-card-column">
                      <section class="claim-info-card">
                        <div class="claim-section-heading">
                          <div>
                            <span>Detail Klaim</span>
                            <small>Informasi utama klaim</small>
                          </div>
                          <v-chip class="claim-status-chip" small>
                            {{ claim.claim_status || "Menunggu Data" }}
                          </v-chip>
                        </div>
                        <div class="claim-detail-list">
                      <div
                        v-for="detail in claimDetailItems"
                        :key="detail.label"
                        class="claim-detail-row"
                      >
                        <span>{{ detail.label }}</span>
                        <strong>{{ detail.value || "-" }}</strong>
                      </div>
                        </div>
                      </section>
                    </v-col>
                    <v-col cols="12" md="6" class="claim-card-column">
                      <div class="claim-document-upload">
                      <section class="claim-document-card claim-document-card--inline">
                        <div class="claim-document-header">
                          <div>
                            <strong>Dokumen Klaim</strong>
                            <small>{{ list_attach.length }} dokumen tersedia</small>
                          </div>
                          <v-btn class="add-document-btn" outlined small @click="OpenFilePicker">
                            <v-icon left small>mdi-upload-outline</v-icon>
                            Tambah Dokumen
                          </v-btn>
                        </div>
                        <v-progress-linear v-if="loading.listattachment" indeterminate color="teal"></v-progress-linear>
                        <div v-if="default_claim_documents.length || list_attach.length" class="claim-document-list">
                          <div v-for="(document, index) in default_claim_documents" :key="`required-document-${index}`" class="claim-document-row is-required">
                            <div class="document-type-icon is-required">
                              <v-icon>mdi-file-document-outline</v-icon>
                            </div>
                            <div class="document-info">
                              <strong>{{ index + 1 }}. {{ document }}</strong>
                              <small>Dokumen wajib klaim</small>
                            </div>
                            <v-chip class="document-status is-required" x-small>Wajib</v-chip>
                            <span class="document-action-placeholder"></span>
                          </div>
                          <div v-for="(item, index) in list_attach" :key="item.attachment_row || item.attachment_path || index" class="claim-document-row">
                            <div class="document-type-icon" :class="AttachmentTypeClass(item.attachment_path)">
                              <v-icon>{{ AttachmentIcon(item.attachment_path) }}</v-icon>
                            </div>
                            <div class="document-info">
                              <strong>{{ AttachmentName(item.attachment_path) }}</strong>
                              <small>Dokumen pendukung klaim</small>
                            </div>
                            <v-chip class="document-status" x-small><span class="status-dot"></span>Tersedia</v-chip>
                            <v-btn :href="item.attachment_path_url" target="_blank" icon small class="document-download-btn" aria-label="Download dokumen">
                              <v-icon small>mdi-download-outline</v-icon>
                            </v-btn>
                          </div>
                        </div>
                        <div v-else-if="!loading.listattachment" class="document-empty-state">
                          <v-icon>mdi-file-document-outline</v-icon>
                          <strong>Belum ada dokumen</strong>
                          <span>Tambahkan dokumen pendukung untuk klaim ini.</span>
                        </div>
                      </section>
                      <v-form
                        enctype="multipart/form-data"
                        ref="form_attachment"
                        lazy-validation
                        class="claim-hidden-uploader"
                      >
                        <vue-dropzone
                          ref="myVueDropzone"
                          id="customdropzone"
                          v-on:vdropzone-file-added="HandleFileAdded"
                          :options="dropzoneOptions"
                        ></vue-dropzone>
                      </v-form>
                      <v-btn v-if="pendingUpload" class="claim-upload-btn" depressed @click="Confirm(url_type, '')"
                        ><v-icon left>mdi-upload-outline</v-icon>Unggah Lampiran</v-btn
                      >
                      </div>
                    </v-col>
                  </v-row>
                </v-layout>
                <section class="claim-subrogation-section">
                  <div class="claim-subrogation-header">
                    <div class="claim-subrogation-icon">
                      <v-icon>mdi-cash-multiple</v-icon>
                    </div>
                    <div>
                      <strong>Subrogasi</strong>
                      <small>Informasi pemulihan klaim dan nilai subrogasi</small>
                    </div>
                  </div>
                  <v-data-table
                    :headers="headers_subro"
                    :items="list_subro"
                    :search="search.subro"
                    item-key="policy_ano"
                    class="elevation-0 claim-data-table claim-subrogation-table"
                    :footer-props="{
                      showFirstLastPage: true,
                      firstIcon: 'mdi-page-first',
                      lastIcon: 'mdi-page-last',
                      prevIcon: 'mdi-chevron-left',
                      nextIcon: 'mdi-chevron-right'
                    }"
                    dense
                    :loading="loading.listsubro"
                    loading-text="Loading... Please wait"
                  ></v-data-table>
                </section>
                </template>
              </v-tab-item>
              <v-tab-item value="claimtab-2">
                <v-progress-linear
                  indeterminate
                  color="primary"
                  v-if="loading.detail"
                ></v-progress-linear>
                <div class="claim-table-toolbar">
                  <v-text-field
                    v-model="search.list"
                    prepend-inner-icon="mdi-magnify"
                    placeholder="Cari data klaim..."
                    outlined
                    dense
                    hide-details
                    class="claim-table-search"
                  ></v-text-field>
                  <v-btn
                    class="claim-export-btn"
                    depressed
                    :disabled="!list.length"
                    @click="ExportClaimExcel"
                  >
                    <v-icon left>mdi-file-excel-outline</v-icon>
                    Export Excel
                  </v-btn>
                </div>
                  <v-data-table
                    :headers="headers"
                    :items="list"
                    :search="search.list"
                  @click:row="UploadDoc"
                  item-key="policy_ano"
                  class="elevation-0 claim-data-table claim-inquiry-table"
                  :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'mdi-page-first',
                    lastIcon: 'mdi-page-last',
                    prevIcon: 'mdi-chevron-left',
                    nextIcon: 'mdi-chevron-right'
                  }"
                  dense
                  :loading="loading.list"
                  loading-text="Loading... Please wait"
                >
                  <template v-slot:item.claim_clientproductid="{ item }">
                    {{ item.claim_clientproductid }} -
                    {{ item.claim_clientproductname }}
                  </template>
                  <template v-slot:item.claim_branchclientid="{ item }">
                    {{ item.claim_branchclientid }} -
                    {{ item.claim_branchclientname }}
                  </template>
                  <template v-slot:item.claim_dol="{ item }">
                    {{ $functions.FormatDateIndo(item.claim_dol) }}
                  </template>
                  <template v-slot:item.claim_reportdate="{ item }">
                    {{ $functions.FormatDateIndo(item.claim_reportdate) }}
                  </template>
                  <template v-slot:item.action="{ item }">
                    <v-icon
                      class="mr-2"
                      color="#00b0e4"
                      @click.stop="UploadDoc(item)"
                      title="Upload Dokumen"
                      >mdi-upload-box</v-icon
                    >
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
            <v-dialog v-model="confirm.dialog" max-width="420" persistent>
              <v-card>
                <v-card-title>{{ confirm.title }}</v-card-title>
                <v-card-text>Unggah dokumen yang telah dipilih?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="confirm.dialog = false">Batal</v-btn>
                  <v-btn color="primary" depressed @click="Write">{{ confirm.text }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-snackbar
              v-model="snackbar.dialog"
              :color="snackbar.color"
              :timeout="snackbar.timeout"
              rounded="pill"
              bottom
            >
              {{ snackbar.text }}
              <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar.dialog = false">Close</v-btn>
              </template>
            </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "AppPgdClaim",
  data: () => ({
    pendingUpload: false,
    pending_pegadaian: 0,
    pending_takaful: 0,
    claimtab: null,
    attachmenttab: null,
    url_type: "add",
    claim: {
      claim_id: "",
      claim_polno: "",
      claim_vehno: "",
      claim_dol: "",
      claim_reportdate: "",
      claim_desc: "",
      claim_status: "",
      claim_status_code: "",
      claim_category: "",
      claim_productname: "",
      claim_branchclientname: "",
      claim_branchclientarea: "",
      claim_branchclientkanwil: "",
      datavalue: ""
    },
    list: [],
    list_attach: [],
    list_subro: [],
    search: { list: "", subro: "" },
    loading: { list: false, listattachment: false, listsubro: false },
    formresponse: new FormData(),
    confirm: { dialog: false, title: "Unggah Dokumen", text: "Unggah" },
    snackbar: { dialog: false, color: "success", text: "", timeout: 3000 },
    dropzoneOptions: {
      url: "/",
      thumbnailWidth: 200,
      autoProcessQueue: false,
      uploadMultiple: true,
      maxFiles: 10,
      addRemoveLinks: true,
      acceptedFiles: ".xls,.xlsx,.doc,.docx,.pdf,.jpeg,.jpg,.png,.eml",
      dictDefaultMessage: "UNGGAH LAMPIRAN KLAIM DISINI"
    },
    headers: [
      { text: "ID", value: "claim_id" },
      { text: "Kategori", value: "claim_category" },
      { text: "No Polis", value: "claim_refid" },
      { text: "Produk", value: "claim_clientproductid" },
      { text: "Objek Info", value: "claim_vehno" },
      { text: "Tanggal kejadian", value: "claim_dol" },
      { text: "Tanggal laporan", value: "claim_reportdate" },
      { text: "Kronologi", value: "claim_description" },
      { text: "Outlet", value: "claim_branchclientid" },
      { text: "Area", value: "claim_branchclientarea" },
      { text: "Kanwil", value: "claim_branchclientkanwil" },
      { text: "Status", value: "claim_statusdesc" },
      { text: "#", value: "action", sortable: false, align: "center", width: "1%" }
    ],
    headers_subro: [
      { text: "Keterangan", value: "claimsubro_description" },
      { text: "Tanggal Referensi", value: "claimsubro_refdate" },
      { text: "No Referensi", value: "claimsubro_refno" },
      { text: "Catatan", value: "claimsubro_remarks" },
      { text: "Mata Uang", value: "claimsubro_ccy" },
      { text: "Total", value: "claimsubro_amount" },
      { text: "Status", value: "claimsubro_status" }
    ],
    default_claim_documents: [
      "Copy AKAD, Polis dan endorsement (bila ada) atas kendaraan yang mengalami kerugian",
      "Formulir klaim",
      "Surat Laporan pengajuan klaim berikut kronologis kejadian",
      "STNK / Copy BPKB",
      "Laporan kepolisian, minimal dari Polsek setempat",
      "Foto copy SIM pengemudi KTP pemilik kendaraan yang masih berlaku, kartu keluarga"
    ]
  }),
  created() {
    this.GetTotalClaim();
    this.GetClaimData();
  },
  computed: {
    claimDetailItems() {
      return [
        { label: "No. Klaim", value: this.claim.claim_id },
        { label: "Jenis / Produk", value: this.claim.claim_productname || this.claim.claim_category },
        { label: "No. Polis", value: this.claim.claim_polno },
        { label: "Objek Klaim", value: this.claim.claim_vehno },
        { label: "Tanggal Kejadian", value: this.claim.claim_dol },
        { label: "Tanggal Laporan", value: this.claim.claim_reportdate },
        { label: "Outlet", value: this.claim.claim_branchclientname },
        { label: "Area / Kanwil", value: [this.claim.claim_branchclientarea, this.claim.claim_branchclientkanwil].filter(Boolean).join(" / ") },
        { label: "Kronologi", value: this.claim.claim_desc }
      ];
    },
    claimProgressSteps() {
      return [
        { label: "CLAIM VERIFICATION" },
        { label: "ASSESOR ESTIMATE" },
        { label: "PENDING DOCUMENT" },
        { label: "PENDING PAYMENT" }
      ];
    },
    visibleClaimProgressSteps() {
      return this.claimProgressSteps.map((step, position) => {
        return {
          ...step,
          key: `step-${position}`,
          originalIndex: position,
          isEllipsis: false
        };
      });
    },
    claimProgressIndex() {
      const statusCode = String(this.claim.claim_status_code || "")
        .trim()
        .toUpperCase();
      const statusDescription = String(this.claim.claim_status || "")
        .trim()
        .toUpperCase();
      const codeSteps = {
        M: 2,
        N: 0,
        I: 2,
        L: 2,
        T: 3,
        P: 3,
        O: 3
      };
      if (Object.prototype.hasOwnProperty.call(codeSteps, statusCode)) {
        return codeSteps[statusCode];
      }
      const status = `${statusCode} ${statusDescription}`.trim();
      if (/PAYMENT|DISPOSITION|CLOSE|CLOSED|SELESAI|SIGN|PUBLISH|ISSUE CLAIM NOTE/.test(status)) return 3;
      if (/PENDING DOCUMENT|ACCEPT|VERIFICATION DOCUMENT|VERDOC|DOCUMENT|SPK|RESERVE|RESERVED|CLAIM INPUT|REGISTRATION|REGISTER/.test(status)) return 2;
      if (/ASSESOR|ASSESSOR|ASSESMENT|ASSESSMENT|ESTIMATE|CLAIM SURVEY|SURVEY INFO/.test(status)) return 1;
      return 0;
    },
  },
  watch: {
    "loading.listattachment"(value, previousValue) {
      if (previousValue && !value) this.pendingUpload = false;
    }
  },
  methods: {
    ExportClaimExcel() {
      if (!this.list.length) return;
      const headers = this.headers.filter(header => header.value !== "action");
      const query = String(this.search.list || "")
        .trim()
        .toLowerCase();
      const exportRows = query
        ? this.list.filter(item =>
            headers.some(header =>
              String(item[header.value] || "")
                .toLowerCase()
                .includes(query)
            )
          )
        : this.list;
      const escapeHtml = value =>
        String(value === null || value === undefined ? "" : value)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#39;");
      const headerRow = headers
        .map(header => `<th>${escapeHtml(header.text)}</th>`)
        .join("");
      const dataRows = exportRows
        .map(item => {
          const cells = headers
            .map(header => `<td>${escapeHtml(item[header.value])}</td>`)
            .join("");
          return `<tr>${cells}</tr>`;
        })
        .join("");
      const table = `<table><thead><tr>${headerRow}</tr></thead><tbody>${dataRows}</tbody></table>`;
      const blob = new Blob(["\ufeff" + table], {
        type: "application/vnd.ms-excel"
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `daftar-klaim-${new Date().toISOString().slice(0, 10)}.xls`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    AttachmentName(path) {
      if (!path) return "Dokumen tanpa nama";
      return String(path)
        .split(/[\\/]/)
        .pop();
    },
    AttachmentIcon(path) {
      const extension = String(path || "")
        .split(".")
        .pop()
        .toLowerCase();
      if (extension === "pdf") return "mdi-file-pdf-box";
      if (["jpg", "jpeg", "png", "gif", "webp"].includes(extension)) {
        return "mdi-file-image-outline";
      }
      if (["xls", "xlsx", "csv"].includes(extension)) {
        return "mdi-file-excel-outline";
      }
      return "mdi-file-document-outline";
    },
    AttachmentTypeClass(path) {
      const extension = String(path || "")
        .split(".")
        .pop()
        .toLowerCase();
      if (extension === "pdf") return "is-pdf";
      if (["jpg", "jpeg", "png", "gif", "webp"].includes(extension)) {
        return "is-image";
      }
      if (["xls", "xlsx", "csv"].includes(extension)) return "is-sheet";
      return "is-file";
    },
    OpenFilePicker() {
      const component = this.$refs.myVueDropzone;
      if (!component) return;
      const dropzoneInput =
        component.dropzone && component.dropzone.hiddenFileInput;
      const elementInput =
        component.$el && component.$el.querySelector('input[type="file"]');
      const input = dropzoneInput || elementInput;
      if (input) {
        input.click();
      } else if (component.$el) {
        component.$el.click();
      }
    },
    HandleFileAdded(file) {
      this.pendingUpload = true;
      this.AppendFile(file);
    },
    SnackBar(dialog, color, text, timeout) {
      this.snackbar.dialog = dialog;
      this.snackbar.color = color;
      this.snackbar.text = text;
      this.snackbar.timeout = timeout;
    },
    GetData(flag) {
      if (flag === "pendingpegadaian" || flag === "pendingtakaful") {
        this.claimtab = "claimtab-2";
        this.GetClaimData(flag);
      }
    },
    GetTotalClaim() {
      const formData = new FormData();
      formData.append("websitef", "Y");
      this.$axios
        .post(this.$functions.SafeURL("apiPegadaianClaimTotal", ""), formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => {
          const feedback = response.data;
          if (feedback.length > 0 && feedback[0].feedback === "Y") {
            this.pending_pegadaian = feedback
              .filter(
                item =>
                  item.feedback === "Y" &&
                  (item.claim_status === "M" || item.claim_status === "N")
              )
              .reduce((total, item) => total + Number(item.claim_count || 0), 0);
            this.pending_takaful = feedback
              .filter(
                item => item.feedback === "Y" && item.claim_status === "I"
              )
              .reduce((total, item) => total + Number(item.claim_count || 0), 0);
          } else {
            this.pending_pegadaian = 0;
            this.pending_takaful = 0;
          }
        })
        .catch(error => this.SnackBar(true, "error", error.message, 3000));
    },
    SubmitClaimRequest(claim) {
      const formData = new FormData();
      formData.append("url_type", "add");
      formData.append("claim_rule", "client");
      formData.append("claim_ano", claim.claim_ano);
      formData.append("claim_polno", claim.claim_polno);
      formData.append("claim_dol", claim.claim_dol);
      formData.append("claim_reportdate", claim.claim_reportdate);
      formData.append("claim_vehno", claim.claim_vehno);
      formData.append("claim_noc", claim.claim_noc);
      formData.append("claim_location", claim.claim_losslocation);
      formData.append("claim_description", claim.claim_lossdescription);
      formData.append("claim_name", claim.claim_name);
      formData.append("claim_phone", claim.claim_phone);
      formData.append("claim_upload", "Y");
      formData.append("uploads_sideleft", claim.uploads_sideleft);
      formData.append("uploads_sideright", claim.uploads_sideright);
      formData.append("uploads_sideback", claim.uploads_sideback);
      formData.append("uploads_sidefront", claim.uploads_sidefront);
      return this.$axios
        .post(this.$functions.SafeURL("apiWriteClaim", ""), formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => response.data);
    },
    SearchPolicy(vehicle) {
      const formData = new FormData();
      formData.append("careclaim_vehicle", vehicle);
      formData.append("order_by", "a.POLICYNO,a.ADATE,a.ASTATUS");
      formData.append("order_type", "DESC");
      return this.$axios
        .post(this.$functions.SafeURL("apiListCareSearchPolicy", ""), formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => response.data);
    },
    GetClaimData(flag = "") {
      this.loading.list = true;
      const formData = new FormData();
      formData.append("datavalue", this.claim.datavalue);
      if (flag === "pendingpegadaian") {
        formData.append("claim_pendingpegadaianf", "Y");
      } else if (flag === "pendingtakaful") {
        formData.append("claim_pendingtakafulf", "Y");
      }
      this.$axios
        .post(this.$functions.SafeURL("apiListClaimPegadaian", ""), formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => {
          const feedback = response.data;
          if (feedback.length > 0 && feedback[0].feedback !== "Y") {
            this.list = [];
            this.SnackBar(true, "error", feedback[0].feedback, 0);
          } else {
            this.list = feedback;
          }
        })
        .catch(error => this.SnackBar(true, "error", error.message, 3000))
        .finally(() => { this.loading.list = false; });
    },
    UploadDoc(item) {
      this.claimtab = "claimtab-1";
      this.claim.claim_id = item.claim_id;
      this.claim.claim_polno = item.claim_polno;
      this.claim.claim_vehno = item.claim_vehno;
      this.claim.claim_dol = item.claim_dol;
      this.claim.claim_reportdate = item.claim_reportdate;
      this.claim.claim_desc = item.claim_description;
      this.claim.claim_status = item.claim_statusdesc;
      this.claim.claim_status_code = item.claim_status;
      this.claim.claim_category = item.claim_category;
      this.claim.claim_productname = item.claim_clientproductname;
      this.claim.claim_branchclientname = item.claim_branchclientname;
      this.claim.claim_branchclientarea = item.claim_branchclientarea;
      this.claim.claim_branchclientkanwil = item.claim_branchclientkanwil;
      this.ListAttachment(item.claim_id);
    },
    AppendFile(file) {
      this.formresponse.append("file", file);
    },
    Confirm(flag) {
      if (flag !== "add" && flag !== "edit") return;
      const form = this.$refs.form_attachment;
      if (form && form.validate()) {
        this.url_type = flag;
        this.confirm.title = "Unggah Dokumen";
        this.confirm.text = "Unggah";
        this.confirm.dialog = true;
      }
    },
    Write() {
      this.confirm.text = "Loading...";
      this.formresponse.append("url_type", "add");
      this.formresponse.append("attachment_refno", this.claim.claim_id);
      this.$axios
        .post(
          this.$functions.SafeURL("apiWriteAttachmentPegadaian", ""),
          this.formresponse,
          { headers: { "Content-Type": "multipart/form-data" } }
        )
        .then(response => {
          const feedback = response.data;
          if (feedback.length > 0 && feedback[0].feedback === "Y") {
            const feed = `Success : ${feedback[0].feedback_success}, Failed : ${feedback[0].feedback_failed}`;
            const dropzone = this.$refs.myVueDropzone;
            if (dropzone) dropzone.removeAllFiles();
            this.formresponse = new FormData();
            this.pendingUpload = false;
            this.confirm.dialog = false;
            this.SnackBar(true, "success", feed, 3000);
            this.ListAttachment(this.claim.claim_id);
          } else {
            const message =
              feedback.length > 0
                ? feedback[0].feedback
                : this.$functions.ErrorCode();
            this.SnackBar(true, "error", message, 0);
          }
        })
        .catch(error => this.SnackBar(true, "error", error.message, 3000))
        .finally(() => { this.confirm.text = "Unggah"; });
    },
    ListAttachment(id) {
      this.loading.listattachment = true;
      const formData = new FormData();
      formData.append("attachment_modul", "claimpgdattach");
      formData.append("attachment_refno", id);
      formData.append("limit", 10);
      this.$axios
        .post(this.$functions.SafeURL("apiListAttachment", ""), formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => {
          const feedback = response.data;
          if (feedback.length > 0 && feedback[0].feedback !== "Y") {
            this.list_attach = [];
            this.SnackBar(true, "error", feedback[0].feedback, 0);
          } else {
            this.list_attach = feedback;
          }
        })
        .catch(error => this.SnackBar(true, "error", error.message, 3000))
        .finally(() => { this.loading.listattachment = false; });
    }
  }
};
</script>

<style scoped>
.pgd-claim { --claim-ink: #17233f; --claim-muted: #68758d; --claim-teal: #147a70; --claim-teal-dark: #0d625b; padding: 22px; border-radius: 18px; background: linear-gradient(145deg, #f7fafc, #eef4f7); }
.claim-summary-row { max-width: 980px; margin: 8px auto 10px; }
.claim-summary-column { padding: 12px !important; }
.claim-summary-card { position: relative; overflow: hidden; min-height: 118px; border: 1px solid rgba(20, 122, 112, 0.13); border-radius: 17px !important; background: linear-gradient(135deg, #fff, #f2faf8); box-shadow: 0 10px 28px rgba(34, 68, 82, 0.08) !important; animation: claim-card-enter 0.55s cubic-bezier(0.22, 1, 0.36, 1) both; transition: transform 0.28s ease, box-shadow 0.28s ease !important; }
.claim-summary-column:nth-child(2) .claim-summary-card { animation-delay: 90ms; }
.claim-summary-card::before { position: absolute; inset: 0 auto 0 0; width: 4px; background: var(--claim-teal); content: ""; }
.claim-summary-card--takaful::before { background: #e3a925; }
.claim-summary-content { position: relative; display: grid; grid-template-columns: auto minmax(0, 1fr) auto auto; align-items: center; gap: 14px; min-height: 118px; padding: 20px 18px 20px 22px; }
.claim-summary-icon { display: grid; width: 46px; height: 46px; place-items: center; border-radius: 13px; background: #dff3ef; }
.claim-summary-card--takaful .claim-summary-icon { background: #fff3d7; }
.claim-summary-icon .v-icon { color: var(--claim-teal); font-size: 25px; }
.claim-summary-card--takaful .claim-summary-icon .v-icon { color: #b87c0d; }
.claim-summary-copy { display: flex; min-width: 0; flex-direction: column; }
.claim-summary-copy span { color: var(--claim-ink); font-size: 14px; font-weight: 800; }
.claim-summary-copy small { margin-top: 4px; color: var(--claim-muted); font-size: 10px; line-height: 1.4; }
.claim-summary-content > strong { color: var(--claim-ink); font-size: 32px; line-height: 1; }
.claim-summary-arrow { color: #8b99a9 !important; font-size: 19px !important; transition: transform 0.25s ease; }
.hover-pending:hover { transform: translateY(-4px); box-shadow: 0 16px 34px rgba(34, 68, 82, 0.14) !important; }
.hover-pending:hover .claim-summary-arrow { color: var(--claim-teal) !important; transform: translateX(4px); }
.claim-progress-card { margin-bottom: 20px; padding: 18px 20px 20px; border: 1px solid #e0e8ed; border-radius: 14px; background: #fff; box-shadow: 0 8px 22px rgba(34, 68, 82, 0.06); }
.claim-progress-card--inside { margin: 18px 10px 0; animation: claim-content-enter 0.4s ease both; }
.claim-progress-heading { display: flex; align-items: center; justify-content: space-between; gap: 16px; margin-bottom: 20px; }
.claim-progress-heading > div { display: flex; flex-direction: column; }
.claim-progress-heading span { color: var(--claim-ink); font-size: 16px; font-weight: 700; }
.claim-progress-heading small { margin-top: 3px; color: var(--claim-muted); }
.claim-progress-status { max-width: 260px; background: #e3f3f0 !important; color: var(--claim-teal-dark) !important; font-weight: 700; }
.claim-progress-status ::v-deep .v-chip__content { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.claim-progress-scroll { overflow-x: auto; overflow-y: hidden; padding: 3px 2px 8px; scrollbar-width: thin; scrollbar-color: #aebdbf transparent; }
.claim-progress-track { display: flex; min-width: 900px; }
.claim-progress-step { position: relative; z-index: 0; display: flex; flex: 1 0 150px; align-items: center; flex-direction: column; text-align: center; }
.claim-progress-step:not(:last-child)::after { position: absolute; z-index: -1; top: 19px; left: calc(50% + 20px); width: calc(100% - 40px); height: 2px; background: #ccd5dc; content: ""; }
.claim-progress-step.is-complete:not(:last-child)::after { background: var(--claim-teal); }
.claim-progress-ellipsis { position: relative; z-index: 0; display: flex; flex: 0 0 82px; height: 40px; align-items: center; justify-content: center; gap: 7px; }
.claim-progress-ellipsis::before { position: absolute; z-index: -1; top: 19px; right: 0; left: 0; height: 2px; background: #ccd5dc; content: ""; }
.claim-progress-ellipsis span { width: 4px; height: 4px; border-radius: 50%; background: #8390a3; box-shadow: 0 0 0 5px #fff; }
.claim-step-marker { display: grid; width: 40px; height: 40px; place-items: center; border: 2px solid #cbd4dc; border-radius: 50%; background: #cbd4dc; color: #fff; font-size: 14px; font-weight: 800; transition: transform 0.2s ease, box-shadow 0.2s ease; }
.claim-progress-step.is-complete .claim-step-marker { border-color: var(--claim-teal); background: var(--claim-teal); }
.claim-progress-step.is-complete .claim-step-marker .v-icon { color: #fff; }
.claim-progress-step.is-active .claim-step-marker { border-color: var(--claim-teal); background: #fff; color: var(--claim-teal-dark); box-shadow: 0 0 0 5px rgba(20, 122, 112, 0.1); transform: scale(1.05); }
.claim-step-label { max-width: 145px; margin-top: 10px; color: #778298; font-size: 12px; font-weight: 600; line-height: 1.35; }
.claim-progress-step.is-active .claim-step-label,
.claim-progress-step.is-complete .claim-step-label { color: var(--claim-ink); font-weight: 700; }
.claim-step-meta { margin-top: 3px; color: #9aa4b3; font-size: 10px; }
.claim-progress-step.is-active .claim-step-meta { color: #11965e; font-weight: 700; }
.claim-main-tabs { overflow: hidden; border: 1px solid #e0e8ed; border-bottom: 0; border-radius: 14px 14px 0 0; background: #fff; }
::v-deep .claim-main-tabs .v-tabs-bar { height: 62px; padding: 7px; background: #fff !important; }
::v-deep .claim-main-tabs .v-tab { min-width: 210px; height: 48px; margin-right: 6px; border-radius: 10px; color: #647188 !important; font-weight: 700; letter-spacing: 0; text-transform: none; }
::v-deep .claim-main-tabs .v-tab .v-icon { color: #7b8494 !important; }
::v-deep .claim-main-tabs .v-tab--active { background: linear-gradient(135deg, #2e427f 0%, #1d2d60 100%) !important; color: #fff !important; box-shadow: inset 0 -3px 0 #f2bd22, 0 8px 18px rgba(29, 45, 96, 0.24); transform: translateY(-1px); }
::v-deep .claim-main-tabs .v-tab--active .v-icon { color: #ffd34f !important; }
.claim-tab-content { overflow: hidden; border: 1px solid #e0e8ed; border-radius: 0 0 14px 14px; background: #fff !important; }
.claim-tab-content ::v-deep .v-window-item--active { animation: claim-content-enter 0.38s ease both; }
.claim-empty-selection { display: flex; min-height: 390px; align-items: center; justify-content: center; flex-direction: column; padding: 44px 24px; text-align: center; background: radial-gradient(circle at 50% 38%, rgba(20, 122, 112, 0.06), transparent 32%); }
.claim-empty-illustration { position: relative; display: grid; width: 82px; height: 82px; margin-bottom: 18px; place-items: center; border-radius: 24px; background: linear-gradient(145deg, #e9f7f4, #d8eeea); box-shadow: 0 12px 28px rgba(20, 122, 112, 0.14); animation: claim-icon-float 3s ease-in-out infinite; }
.claim-empty-illustration::after { position: absolute; inset: -9px; border: 1px solid rgba(20, 122, 112, 0.12); border-radius: 30px; content: ""; }
.claim-empty-illustration .v-icon { color: var(--claim-teal); font-size: 38px; }
.claim-empty-selection h3 { margin: 0; color: var(--claim-ink); font-size: 19px; }
.claim-empty-selection p { max-width: 440px; margin: 8px 0 20px; color: var(--claim-muted); font-size: 13px; line-height: 1.6; }
.claim-open-list-btn { height: 42px !important; padding: 0 20px !important; border-radius: 10px; background: linear-gradient(135deg, #147a70, #0d625b) !important; color: #fff !important; font-weight: 700; letter-spacing: 0; text-transform: none; box-shadow: 0 8px 18px rgba(20, 122, 112, 0.22); transition: transform 0.2s ease, box-shadow 0.2s ease; }
.claim-open-list-btn:hover { transform: translateY(-2px); box-shadow: 0 12px 24px rgba(20, 122, 112, 0.28); }
.claim-detail-grid { align-items: stretch; }
.claim-card-column { display: flex; padding: 8px !important; }
.claim-info-card,
.claim-document-upload { width: 100%; overflow: hidden; border: 1px solid #e1e7ec; border-radius: 13px; background: #fff; box-shadow: 0 8px 22px rgba(34, 68, 82, 0.07); }
.claim-section-heading { display: flex; align-items: center; justify-content: space-between; padding: 18px 22px 12px !important; border-bottom: 1px solid #edf0f3; }
.claim-section-heading > div { display: flex; flex-direction: column; }
.claim-section-heading span { color: var(--claim-ink); font-size: 17px; font-weight: 700; }
.claim-section-heading small { margin-top: 3px; color: var(--claim-muted); }
.claim-status-chip { background: #dff4e8 !important; color: #08764d !important; font-weight: 700; }
.claim-detail-list { padding: 8px 22px 20px !important; }
.claim-detail-row { display: grid; grid-template-columns: minmax(110px, 0.7fr) minmax(0, 1.3fr); gap: 14px; padding: 10px 0; border-bottom: 1px solid #edf0f3; }
.claim-detail-row:last-child { border-bottom: 0; }
.claim-detail-row span { color: var(--claim-muted); font-size: 11px; }
.claim-detail-row strong { overflow-wrap: anywhere; color: #344158; font-size: 11px; font-weight: 600; }
.claim-document-upload { padding: 0 0 16px !important; }
.document-upload-heading { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 14px; }
.document-upload-heading > div { display: flex; flex-direction: column; }
.document-upload-heading strong { color: var(--claim-ink); font-size: 15px; }
.document-upload-heading small { margin-top: 2px; color: var(--claim-muted); font-size: 11px; }
.document-upload-heading .v-icon { color: var(--claim-teal); }
.vue-dropzone { border: 1.5px dashed #77b8b1; color: var(--claim-teal); border-radius: 13px; background: #f2faf8; font-size: 18px; font-weight: 600; }
.claim-hidden-uploader { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); opacity: 0; }
.claim-upload-btn { width: calc(100% - 32px); min-height: 40px; margin: 0 16px; padding: 0 20px !important; border-radius: 9px; background: var(--claim-teal) !important; color: #fff !important; font-weight: 700; letter-spacing: 0; text-transform: none; box-shadow: 0 7px 16px rgba(20, 122, 112, 0.2); }
.claim-document-tabs { margin: 18px 10px 10px; overflow: hidden; border: 1px solid #e1e7ec; border-radius: 13px; background: #fff; }
::v-deep .claim-document-tabs > .v-tabs-bar { height: 54px; padding: 5px; background: #f5f8fa !important; }
::v-deep .claim-document-tabs > .v-tabs-bar .v-tab { height: 44px; border-radius: 9px; color: #657188 !important; font-weight: 700; letter-spacing: 0; text-transform: none; }
::v-deep .claim-document-tabs > .v-tabs-bar .v-tab--active { background: #e3f3f0 !important; color: var(--claim-teal-dark) !important; }
.claim-document-card { margin: 10px; overflow: hidden; border: 1px solid #e1e7ec; border-radius: 12px; background: #fff; }
.claim-document-card--inline { margin: 0 0 14px; border: 0; border-radius: 0; }
.claim-document-card--inline .claim-document-list { max-height: 310px; overflow-y: auto; }
.claim-document-card--inline .document-empty-state { min-height: 120px; }
.claim-document-header { display: flex; align-items: center; justify-content: space-between; gap: 16px; min-height: 66px; padding: 12px 16px; border-bottom: 1px solid #e8edf0; }
.claim-document-header > div { display: flex; flex-direction: column; }
.claim-document-header strong { color: var(--claim-ink); font-size: 15px; }
.claim-document-header small { margin-top: 2px; color: var(--claim-muted); font-size: 10px; }
.add-document-btn { height: 38px !important; border-color: #b8ccc9 !important; border-radius: 9px; color: var(--claim-teal-dark) !important; font-weight: 700; letter-spacing: 0; text-transform: none; }
.claim-document-list { padding: 0 16px; }
.claim-document-row { display: grid; grid-template-columns: auto minmax(0, 1fr) auto auto; align-items: center; gap: 11px; min-height: 56px; border-bottom: 1px solid #edf1f3; }
.claim-document-row:last-child { border-bottom: 0; }
.document-type-icon { display: grid; width: 30px; height: 34px; place-items: center; border-radius: 7px; background: #edf2f6; }
.document-type-icon .v-icon { color: #62718a; font-size: 21px; }
.document-type-icon.is-pdf { background: #fdebed; }
.document-type-icon.is-pdf .v-icon { color: #d8414e; }
.document-type-icon.is-image { background: #e5f5ef; }
.document-type-icon.is-image .v-icon { color: #168263; }
.document-type-icon.is-sheet { background: #e4f3eb; }
.document-type-icon.is-sheet .v-icon { color: #19794d; }
.document-type-icon.is-required { background: #edf2f6; }
.document-type-icon.is-required .v-icon { color: #52637a; }
.document-info { display: flex; min-width: 0; flex-direction: column; }
.document-info strong { overflow: hidden; color: #26344d; font-size: 12px; font-weight: 700; text-overflow: ellipsis; white-space: nowrap; }
.claim-document-row.is-required { min-height: 66px; }
.claim-document-row.is-required .document-info strong { overflow: visible; text-overflow: initial; white-space: normal; }
.document-info small { margin-top: 3px; color: #8994a5; font-size: 10px; }
.document-status { background: #dff4e8 !important; color: #08764d !important; font-size: 9px !important; font-weight: 700; }
.document-status.is-required { background: #edf2f6 !important; color: #52637a !important; }
.document-status .status-dot { width: 5px; height: 5px; margin-right: 4px; }
.document-action-placeholder { width: 28px; }
.document-download-btn { color: #52637a !important; }
.document-download-btn:hover { background: #edf5f4; color: var(--claim-teal) !important; }
.document-empty-state { display: flex; min-height: 180px; align-items: center; justify-content: center; flex-direction: column; padding: 28px; text-align: center; }
.document-empty-state .v-icon { margin-bottom: 8px; color: #a5b1bf; font-size: 34px; }
.document-empty-state strong { color: #435067; font-size: 13px; }
.document-empty-state span { margin-top: 4px; color: #8994a5; font-size: 11px; }
.claim-subrogation-section { margin: 20px 10px 10px; overflow: hidden; border: 1px solid #e1e7ec; border-radius: 13px; background: #fff; }
.claim-subrogation-header { display: flex; align-items: center; gap: 12px; min-height: 68px; padding: 13px 16px; border-bottom: 1px solid #e8edf0; }
.claim-subrogation-header > div:last-child { display: flex; flex-direction: column; }
.claim-subrogation-header strong { color: var(--claim-ink); font-size: 15px; }
.claim-subrogation-header small { margin-top: 2px; color: var(--claim-muted); font-size: 10px; }
.claim-subrogation-icon { display: grid; width: 38px; height: 38px; place-items: center; border-radius: 10px; background: #e5f4f1; }
.claim-subrogation-icon .v-icon { color: var(--claim-teal); font-size: 21px; }
::v-deep .claim-data-table.claim-subrogation-table { margin: 0; border: 0; border-radius: 0; box-shadow: none !important; }
::v-deep .claim-data-table { margin: 10px; overflow: hidden; border: 1px solid #e1e7ec; border-radius: 12px; background: #fff; box-shadow: 0 8px 20px rgba(34, 68, 82, 0.06) !important; }
::v-deep .claim-data-table thead tr { background: #edf4f5; }
::v-deep .claim-data-table thead th { height: 48px; color: #36535f !important; font-size: 12px; font-weight: 800; letter-spacing: 0.04em; text-transform: uppercase; white-space: nowrap; }
::v-deep .claim-data-table tbody td { height: 50px; border-bottom-color: #edf1f3 !important; color: #3f4d63; }
::v-deep .claim-data-table tbody tr:hover td { background: #f3faf8 !important; }
::v-deep .claim-data-table .v-data-footer { min-height: 62px; border-top: 0; }
.claim-table-toolbar { display: flex; align-items: center; justify-content: flex-end; gap: 10px; margin: 20px 10px 0; padding: 14px 16px; border: 1px solid #e1e6ef; border-bottom: 0; border-radius: 14px 14px 0 0; background: #fff; }
.claim-table-search { width: 100%; max-width: 360px; margin-right: auto !important; }
::v-deep .claim-table-search .v-input__slot { min-height: 42px !important; border-radius: 10px !important; background: #fff !important; }
::v-deep .claim-table-search fieldset { border-color: #d5dbea; }
::v-deep .claim-table-search.v-input--is-focused fieldset { border-width: 1px; border-color: #334783; }
.claim-export-btn { height: 42px !important; padding: 0 17px !important; border-radius: 10px; background: #202f68 !important; color: #fff !important; font-size: 13px !important; font-weight: 700; letter-spacing: 0; text-transform: none; box-shadow: 0 7px 16px rgba(32, 47, 104, 0.2); transition: transform 0.2s ease, box-shadow 0.2s ease; }
.claim-export-btn:not(.v-btn--disabled):hover { transform: translateY(-1px); box-shadow: 0 9px 20px rgba(32, 47, 104, 0.28); }
::v-deep .claim-data-table.claim-inquiry-table { margin: 0 10px 18px; border-color: #e1e6ef; border-radius: 0 0 14px 14px; box-shadow: 0 10px 28px rgba(24, 36, 76, 0.07) !important; }
::v-deep .claim-inquiry-table .v-data-table__wrapper { scrollbar-width: thin; scrollbar-color: #a8afba #f0f2f5; }
::v-deep .claim-inquiry-table .v-data-table__wrapper::-webkit-scrollbar { width: 8px; height: 8px; }
::v-deep .claim-inquiry-table .v-data-table__wrapper::-webkit-scrollbar-track { background: #f0f2f5; }
::v-deep .claim-inquiry-table .v-data-table__wrapper::-webkit-scrollbar-thumb { border: 2px solid #f0f2f5; border-radius: 999px; background: #9299a5; }
::v-deep .claim-inquiry-table thead tr { background: #edf3f8; }
::v-deep .claim-inquiry-table thead th { height: 50px; padding: 0 18px; border-bottom: 1px solid #d8e0eb !important; background: #edf3f8; color: #25345f !important; font-size: 12px; letter-spacing: 0.055em; }
::v-deep .claim-inquiry-table tbody td { height: 50px; padding: 0 18px; color: #34405f; font-size: 13px; white-space: nowrap; }
::v-deep .claim-inquiry-table tbody tr { cursor: pointer; }
::v-deep .claim-inquiry-table tbody tr:hover td { background: #f8faff !important; }
::v-deep .claim-inquiry-table .v-data-footer { min-height: 64px; color: #5e687f; }
::v-deep .v-tabs-slider { display: none; }
@keyframes claim-card-enter {
  from { opacity: 0; transform: translateY(16px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}
@keyframes claim-content-enter {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes claim-icon-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
}
@media (max-width: 600px) {
  .pgd-claim { padding: 8px; border-radius: 12px; }
  .claim-summary-row { margin: 8px -4px 4px; }
  .claim-summary-column { padding: 5px !important; }
  .claim-summary-row .v-card__title { padding: 18px; }
  .claim-summary-card { min-height: 96px; border-radius: 13px !important; }
  .claim-summary-content { min-height: 96px; grid-template-columns: auto minmax(0, 1fr) auto; gap: 10px; padding: 14px; }
  .claim-summary-icon { width: 40px; height: 40px; border-radius: 11px; }
  .claim-summary-content > strong { font-size: 27px; }
  .claim-summary-arrow { display: none !important; }
  .claim-progress-card { margin-bottom: 12px; padding: 14px 10px 10px; }
  .claim-progress-card--inside { margin: 10px 5px 0; }
  .claim-progress-heading { align-items: flex-start; flex-direction: column; }
  .claim-progress-status { max-width: 100%; }
  .claim-progress-scroll { margin: 0 -10px; padding-right: 10px; padding-left: 10px; }
  .claim-progress-track { min-width: 690px; }
  .claim-progress-step { flex-basis: 102px; }
  .claim-progress-ellipsis { height: 34px; flex-basis: 62px; }
  .claim-step-marker { width: 34px; height: 34px; }
  .claim-progress-step:not(:last-child)::after,
  .claim-progress-ellipsis::before { top: 16px; }
  .claim-progress-step:not(:last-child)::after { left: calc(50% + 17px); width: calc(100% - 34px); }
  .claim-step-label { max-width: 102px; font-size: 10px; }
  .claim-step-meta { font-size: 9px; }
  .claim-main-tabs { border-radius: 11px 11px 0 0; }
  ::v-deep .claim-main-tabs .v-tabs-bar { height: 56px; padding: 5px; }
  ::v-deep .claim-main-tabs .v-tab { min-width: 158px; height: 44px; padding: 0 10px; font-size: 12px; }
  .claim-tab-content { border-radius: 0 0 11px 11px; }
  .claim-empty-selection { min-height: 330px; padding: 36px 18px; }
  .claim-empty-illustration { width: 70px; height: 70px; border-radius: 20px; }
  .claim-detail-grid { margin: 8px 0 12px !important; }
  .claim-card-column { padding: 5px !important; }
  .claim-info-card,
  .claim-document-upload { border-radius: 11px; }
  .claim-section-heading { padding: 14px 15px 11px !important; }
  .claim-section-heading span { font-size: 15px; }
  .claim-detail-list { padding: 4px 15px 14px !important; }
  .claim-detail-row { grid-template-columns: minmax(92px, 0.7fr) minmax(0, 1.3fr); gap: 10px; padding: 9px 0; }
  .claim-document-header { padding: 11px 12px; }
  .claim-document-list { padding: 0 10px; }
  .claim-document-row { gap: 8px; }
  .document-info strong { max-width: 180px; }
  .claim-upload-btn { width: calc(100% - 24px); margin: 0 12px; }
  .claim-subrogation-section { margin: 12px 5px 8px; border-radius: 11px; }
  .claim-subrogation-header { padding: 12px; }
  ::v-deep .claim-data-table { margin: 5px; border-radius: 10px; }
  ::v-deep .claim-data-table.claim-subrogation-table { margin: 0; border-radius: 0; }
  .claim-table-toolbar { flex-direction: column; align-items: stretch; margin: 12px 5px 0; padding: 12px; }
  .claim-table-search { max-width: none; }
  .claim-export-btn { width: 100%; }
  ::v-deep .claim-data-table.claim-inquiry-table { margin: 0 5px 12px; border-radius: 0 0 10px 10px; }
  ::v-deep .claim-data-table thead th,
  ::v-deep .claim-data-table tbody td { padding-right: 12px; padding-left: 12px; white-space: nowrap; }
  .claim-document-header { align-items: flex-start; flex-direction: column; }
  .add-document-btn { width: 100%; }
  .claim-document-row { grid-template-columns: auto minmax(0, 1fr) auto; }
  .document-status { display: none; }
  .claim-section-heading { align-items: flex-start; flex-direction: column; gap: 10px; }
}
@media (prefers-reduced-motion: reduce) {
  .claim-summary-card,
  .claim-tab-content ::v-deep .v-window-item--active,
  .claim-empty-illustration { animation: none; }
  .claim-summary-card,
  .claim-summary-arrow,
  .claim-open-list-btn { transition: none !important; }
}
</style>
